import moment from "moment";
import { OCCURS_ONCE } from "../model/lighting-overrides/overrideFrequencyKeys";

export const handleStartTimeOptions = () => {
  const timeOptions = [];
  const startTime = moment().startOf("D");

  let quarterHourReadings = null;
  const formattedTime = moment(startTime);
  for (let i = 0; i < 24; i++) {
    for (let x = 0; x <= 3; x++) {
      quarterHourReadings = moment(formattedTime)
        .add(15 * x, "minutes")
        .format("HH:mm");
      timeOptions.push(quarterHourReadings);
    }

    formattedTime.add(1, "hour");
  }
  return timeOptions;
};

export const handleEndTimeOptions = (startDate, startTime, endDate, occurs) => {
  const timeOptions = [];
  let quarterHourReadings = null;

  if (
    occurs === OCCURS_ONCE &&
    startDate != null &&
    endDate != null &&
    !moment(startDate).isSame(moment(endDate), "day")
  ) {
    const startTime = moment(startDate).startOf("D");
    const formattedTime = moment(startTime);
    for (let i = 0; i < 24; i++) {
      for (let x = 0; x <= 3; x++) {
        quarterHourReadings = moment(formattedTime)
          .add(15 * x, "minutes")
          .format("HH:mm");
        timeOptions.push(quarterHourReadings);
      }

      formattedTime.add(1, "hour");
    }
  } else {
    const formatStartDateTime =
      moment(startDate).format("YYYY-MM-DD") + "T" + startTime + ":00";

    const offsetStartTime = moment(formatStartDateTime).add(15, "minutes");

    const hours = 0;
    const formattedTime = moment(offsetStartTime);
    for (let i = 0; i < 24; i++) {
      for (let x = 0; x <= 3; x++) {
        quarterHourReadings = moment(formattedTime)
          .add(15 * x, "minutes")
          .format("HH:mm");
        const totalHours =
          parseInt(hours, 10) + parseFloat(0.25) * parseInt(x + 1, 10) + parseInt(i, 10);
        timeOptions.push(quarterHourReadings + " (" + totalHours + " hrs)");
      }

      formattedTime.add(1, "hour");
    }
  }

  return timeOptions;
};
